import { render } from "./BatchFormAlertsContainer.vue?vue&type=template&id=70b6ccc8"
import script from "./BatchFormAlertsContainer.vue?vue&type=script&lang=js"
export * from "./BatchFormAlertsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__